import React from "react";
import { Box } from "@chakra-ui/react";

export const RouteLoading: React.FC = () => {
  return <Box>...LOADING...</Box>;
};
